<template>
  <el-container>
    <!-- 顶部-->
    <el-header>
      <div style="width: 500px; display: inline-block; font-size: 26px;font-weight: 400; color: #fff;">
        西安伟思特前台信息管理
      </div>

      <el-dropdown trigger="click" style="float: right;">
        <div style="cursor:pointer;display: flex;align-items: center;">
          <el-avatar :src="this.$store.state.baseApi+'/user/null.jpg'" shape="square" :size="40"></el-avatar>
          <el-badge :value="this.$store.state.messageNum">
            <span style="margin-left: 10px; color: #fff;">{{ account }}</span>
          </el-badge>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div @click="pwdUpdate('refform')">修改密码</div>
          </el-dropdown-item>
          <el-dropdown-item divided style="color: red;">
            <div @click="logOut()">安全退出</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </el-header>
    <el-container>
      <!-- 左边-->
      <el-aside width="200px">
        <el-menu :default-openeds="['1', '3']" router>
          <el-menu-item :index="menu.value" v-for="menu in menuList" :key="menu.id">
            {{ menu.label }}
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!-- 工作区-->
      <el-main>
        <router-view></router-view>
        <!-- 让子集组件显示 -->
      </el-main>
    </el-container>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%">
      <el-form ref="refform" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="当前密码" prop="curpwd">
          <el-input v-model="form.curpwd" placeholder="(默认密码为123456)" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input v-model="form.pass" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="form.checkPass" placeholder="请输入确认密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false ">取 消</el-button>
				<el-button type="primary" @click="changePwd()">确 定</el-button>
			</span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (this.flag) {
        callback(new Error('新密码不能与原密码一样'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.refform.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      account: "",
      menuList: [],
      dialogFormVisible: false,
      flag: "",
      /* 输入原密码与正确密码是否一致 */
      form: {
        curpwd: "",
        pass: "",
        checkPass: ""
      },
      rules: {
        curpwd: [{
          required: true,
          message: '当前密码不能为空',
          trigger: 'blur'
        },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        pass: [
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: 'blur'
          }
        ],
        checkPass: [{
          validator: validatePass2,
          trigger: 'blur'
        },
          {
            min: 6,
            max: 15,
            message: '长度在 6 到 15 个字符',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  created() {
    this.account = sessionStorage.getItem("account");

    this.$store.dispatch("getMessageNum");

    this.$api.getMenu().then(res => {
      if (res.code == 200) {
        this.menuList = res.data;
      }
    })
  },
  methods: {
    logOut() {
      this.$confirm('您确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear(); //清除浏览器中存储的用户信息
        this.$router.push("/WesteSound-login");
      })
    },
    pwdUpdate() {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.refform) {
          this.$refs.refform.resetFields(); /* 重置表单中所有的表单项为初始状态 */
        }
      });
    },
    changePwd() {
      this.dialogFormVisible = false;
      this.$api.changePassword({
        currentPassword: this.form.curpwd,
        newPassword: this.form.pass,
        confirmPassword: this.form.checkPass
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: 'success'
          }); //提示
        }
        sessionStorage.clear(); //清除浏览器中存储的用户信息
        this.$router.push("/WesteSound-login");
      })
    },
  },
}
</script>

<style>
.el-header {
  background-color: #23233c;
  color: #333;
  line-height: 60px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  height: 90vh;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: left;
  height: 90vh;
}
</style>